<template>
    <div>
        <div class=" filter_header col-12">
            <div class="header">
                <div class = "collapse-icon">
                    <div data-toggle="collapse" class="filter_button" :aria-expanded="show_filter" @click="show_filter = !show_filter">{{$t('message.filter')}}</div>
                </div>
            </div>
            <div class="center"></div>
            <div class="col-units">
                <!--div class="label">{{$t('message.show_col')}}</div-->
                <!--model-list-select
                    :list="col_array"
                    class="controls"
                    option-value="value"
                    option-text="name"
                    v-model="col"
                    >
                </model-list-select-->
            </div>
        </div>
        <transition name="slide_down">
            <cardWrapper v-if="show_filter">
                <div class="row filter_block">
                    <div class="main col-12">
                        <div class="recomend">
                            <div class="controls">
                                <div class="checkbox checkbox-sm">
                                    <input id="recom" type="checkbox" value="true" v-model="recomend" >
                                    <label for="recom">{{$t('message.recomend')}}</label>
                                </div>    

                            </div> 
                        </div>
                    </div>
                    <div v-if="!recomend" class="col-12 mt-1">
                        <div class="row"> 
                            <div class="col-md-4 mt-1">
                                <div class="header">{{$t('message.injury_type')}}</div>
                                <div class="controls">
                                    <div class="radio radio-primary d-block" v-for="(item, index) in type_array" :key = "item.tag" >
                                        <input :id="'type_'+index"  :value="item.tag" type="radio"  v-model="type_tag" >
                                        <label :for="'type_'+index">{{$t('message.'+item.name)}}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 mt-1">
                                <div class="header">{{$t('message.device_type')}}</div>
                                <div class="controls">
                                    <div class="radio radio-primary d-block" v-for="(item, index) in dev_type_array" :key = "item.tag" >
                                        <input :id="'dev_type_'+index"  :value="item.tag" type="radio"  v-model="dev_type_tag" >
                                        <label :for="'dev_type_'+index">{{$t('message.'+item.name)}}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 mt-1">
                                <div class="header">{{$t('message.age')}}</div>
                                <div class="controls">
                                    <div class="radio radio-primary d-block" v-for="(item, index) in old_array" :key = "item.tag" >
                                        <input :id="'old_'+index"  :value="item.tag" type="radio"  v-model="old_tag" >
                                        <label :for="'old_'+index">{{$t('message.'+item.name)}}</label>
                                    </div>
                                </div> 
                            </div>
                            
                            <div class="main col-12 reset_filter" v-if="tags.length > 0">
                            <div class="col-12 ">
                                <a @click.prevent="reset" class="float-right"><font-awesome-icon :icon="['fas', 'times']"/> {{$t('message.reset_filter')}}</a>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </cardWrapper>
        </transition>    
    </div>   
</template>
<script>
     import cardWrapper from '@/components/cardWrapper';
     //import { ModelListSelect } from 'vue-search-select';
    export default{
        name: 'catalog_filter',
        props:{
            col_units: {
                type: Number,
            }
        },
        data() {
            return{
               show_filter:false,
               recomend:false,
               tags:[],
               
               dev_type_tag:null,
               old_tag:null,
               type_tag:null,
               
               col:null,
               col_array:[{name:'20',value:20},{name:'50',value:50},{name:'Все',value:'all'}],
               old_array:[
                   {name:'preschool',tag:'Preschool'},
                   {name:'gradeschooler', tag:'Gradeschooler'},
                   {name:'teen', tag:'Teen'},
                   {name:'adult', tag:'Adult'},
               ],
               type_array:[
                   {name:'WRIST_INJURY',tag:'Wrist'},
                   {name:'FOREARM_INJURY', tag:'Forearm'}
               ],
               dev_type_array:[
                   {name:'mechanic',tag:'Mechanic'},
                   {name:'bionic', tag:'Bionic'},
               ],
            }
        },
        
        components: {cardWrapper},
        created(){
            this.col = this.col_units 
            this.$emit('filter_change', {tags: [], perpage:this.col, recomend:this.recomend})
         },
        watch: {
            dev_type_tag: function () {
                this.setTags()
            },
            old_tag: function () {
                this.setTags()
            },
            type_tag: function () {
                this.setTags()
            },
            
            tags: function (val) {
                this.$emit('filter_change',{ tags: val, perpage:this.col, recomend:false}) 
            },
            col: function (val) {
                this.$emit('filter_change',{ tags: this.tags, perpage:val, recomend:this.recomend})
            },
            recomend: function (val) {
                this.$emit('filter_change',{ tags:this.tags, perpage:this.col, recomend:val}) 
            },
        },
          
        methods:{
            setTags:function(){
                this.tags=[]
                let tags =[]
                if(this.dev_type_tag) tags.push(this.dev_type_tag)
                if(this.old_tag) tags.push(this.old_tag)
                if(this.type_tag) tags.push(this.type_tag)
                this.tags=tags
            },
            reset:function(){  
                this.dev_type_tag=null
                this.old_tag=null
                this.type_tag=null
                this.tags=[]
            }
        }

    }
</script>
<style>
    
    .filter_header{
        display: flex;
        align-items: center;
        justify-content:space-between;
        border-bottom: 1px solid #DFE3E7; 
        margin-bottom: 10px;
        padding-bottom: 5px;
      
    }
    .filter_header .header{
       text-transform: uppercase;
       padding-right: 34px;
       display: inline-block;
       position: relative;
    }
    .reset a{
        cursor: pointer;
    }
    
    .filter_header .center{
         display: flex;
    }
    .filter_header .col-units{
        display: flex;
        align-items: center;
        justify-content:space-between;
        justify-content:space-between;
    }
    .reset_filter{
        cursor: pointer;
    }
    
    .filter_header .col-units .ui.fluid.dropdown{
        min-width: 100px;
    }
    
    .filter_block .header{
         border-bottom: 1px solid #DFE3E7; 
         margin-bottom: 10px;
         text-transform: uppercase;
    }
    .filter_block .main{
        justify-content:space-between;
        display: flex;
        width: 100%;
    }
    .filter_block .main .recomend{
        display: flex;
    }
    .filter_block .main .reset{
        display: flex;
    }
    
    
    
    .filter_header .col-units .label{
        display: flex;
        white-space: nowrap;
        padding-right: 10px;
        justify-content:space-between;
    }
    
    
    .filter_header .collapse-icon [data-toggle=collapse]:before{
        top: -3px;
    }
    .slide_down-enter-active {
   -moz-transition-duration: 0.3s;
   -webkit-transition-duration: 0.3s;
   -o-transition-duration: 0.3s;
   transition-duration: 0.3s;
   -moz-transition-timing-function: ease-in;
   -webkit-transition-timing-function: ease-in;
   -o-transition-timing-function: ease-in;
   transition-timing-function: ease-in;
}

.slide_down-leave-active {
   -moz-transition-duration: 0.3s;
   -webkit-transition-duration: 0.3s;
   -o-transition-duration: 0.3s;
   transition-duration: 0.3s;
   -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide_down-enter-to, .slide-leave {
   max-height: 100px;
   overflow: hidden;
}

.slide_down-enter, .slide-leave-to {
   overflow: hidden;
   max-height: 0;
}
.filter_button{
    cursor: pointer;
}
    
</style>    